// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { FooterMenuItemFragmentDoc } from './FooterMenuItem.fragment.generated';
export const FooterMenuFragmentDoc = gql`
    fragment footerMenu on FooterColumn {
  items {
    ...footerMenuItem
  }
}
    ${FooterMenuItemFragmentDoc}`;